var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-store-bar"},[_c('div',{on:{"click":_vm.openStorePicker}},[_vm._v(" "+_vm._s(_vm.storeDisplay)+" "),_c('font-awesome-icon',{attrs:{"icon":"map-location-dot"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }